import React from "react";
import { Controller } from "react-hook-form";
import * as MuiMaterial from "@mui/material";
import { MobileDatePicker } from "@mui/x-date-pickers";
import { useTranslation } from "react-i18next";
import { mandatory } from "../../utils/Functions";

export default function Date({
  errors,
  control,
  pickerTitle,
  format,
  label,
  rulesValue,
  slotPropsValue,
  name,
  disabled = false,
  disableFuture = false,
  testId,
  ...rest
}) {
  const { t } = useTranslation();

  const rule = rulesValue ?? {
    required: {
      value: true,
      message: pickerTitle ?? t("ChooseDate"),
    },
  };

  return (
    <Controller
      disabled={disabled}
      name={name}
      control={control}
      rules={rule}
      render={({ field: { value, onChange }, fieldState: { error } }) => {
        return (
          <MuiMaterial.FormControl fullWidth error={!!error}>
            <MobileDatePicker
              value={value ?? null}
              disableFuture={disableFuture}
              onChange={onChange}
              label={label ?? mandatory(t("DateOfAppointment"))}
              format={format ?? "DD/MM/YYYY"}
              slotProps={{
                textField: {
                  error: !!error,
                  ...(testId && { inputProps: { "data-testid": testId } }),
                },
                ...(testId && {
                  previousIconButton: { "data-testid": `${testId}.prev-month` },
                  nextIconButton: { "data-testid": `${testId}.next-month` },
                  day: (ownerState) => ({
                    "data-testid": `${testId}.day-${ownerState.day.format("YYYY-MM-DD")}`,
                  }),
                }),
              }}
              {...rest}
            />
            <MuiMaterial.FormHelperText>
              {error?.message}
            </MuiMaterial.FormHelperText>
          </MuiMaterial.FormControl>
        );
      }}
    />
  );
}
